/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type OrderBackgroundCheckRequest = {
    /**
     * Numeric MinistrySafe background check level. Required unless custom_package_code is given; the two are mutually exclusive.
     */
    level?: number | null;
    /**
     * Custom background check package code, as returned by the levels endpoint. Required unless level is given; the two are mutually exclusive.
     */
    custom_package_code?: string | null;
    /**
     * Whether this person is a current or prospective employee or volunteer
     */
    employee_type: OrderBackgroundCheckRequest.employee_type;
    /**
     * Whether this person works with children or youth
     */
    child_serving: boolean;
    /**
     * What this person is to the organization. Note: this will adjust the MS user to whichever is chosen.
     */
    user_type: OrderBackgroundCheckRequest.user_type;
};

export namespace OrderBackgroundCheckRequest {

    /**
     * Whether this person is a current or prospective employee or volunteer
     */
    export enum employee_type {
        CURRENT = 'current',
        PROSPECTIVE = 'prospective',
    }

    /**
     * What this person is to the organization. Note: this will adjust the MS user to whichever is chosen.
     */
    export enum user_type {
        EMPLOYEE = 'employee',
        VOLUNTEER = 'volunteer',
    }


}

